import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MaterialModule } from 'src/app/material.module';

import { CarouselImageModule } from '../carousel-image/module';
import { DirectivesModule } from '../directives/module';

import { ProductInfoModule } from '../product-info/module';

import { ListingApiService } from './services/listing-api-service';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { CategoryModule } from '../category/module';
import { AuditLog } from './components/audit-log/component';
import { ListingEdit } from './components/edit/component';
import { CohortsModule } from '../cohorts/module';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    DirectivesModule,
    AppRoutingModule,
    CarouselImageModule,
    ProductInfoModule,
    CategoryModule,
    CohortsModule
  ],
  declarations: [ListingEdit, AuditLog],
  providers: [ListingApiService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [],
})
export class ListingModule {}
